import ArticleLayout from '@/components/ArticleLayout';

export default function DisclaimerPage() {
  return (
    <ArticleLayout
      title="Disclaimer"
      description="Important disclaimers and legal notices for the CSSBuy Spreadsheet resource website."
      breadcrumbs={[
        { label: 'Home', to: '/' },
        { label: 'Disclaimer', to: '/disclaimer' },
      ]}
      lastUpdated="2026-08-30"
    >
      <h2>Independent Informational Resource</h2>
      <p>
        This website is an independent informational resource. It is not the official CSSBuy website. We are not affiliated with, endorsed by, or sponsored by CSSBuy or any related entities.
      </p>

      <h2>No Financial or Purchase Processing</h2>
      <p>
        We do not process payments, orders, refunds, or shipping. We do not sell products directly. All purchasing decisions and transactions must be made through the official CSSBuy platform or other authorized channels.
      </p>

      <h2>Information Accuracy</h2>
      <p>
        While we strive to provide accurate and up-to-date information, we do not guarantee the completeness, accuracy, or reliability of any content on this website. Product information, prices, availability, and shipping details may change without notice. Always verify current information directly with CSSBuy or the relevant seller before making any purchase.
      </p>

      <h2>No Guarantees</h2>
      <p>
        We do not guarantee the quality, authenticity, or reliability of any products, sellers, or services mentioned on this website. Users are solely responsible for their own purchasing decisions and should conduct their own due diligence.
      </p>

      <h2>External Links</h2>
      <p>
        This website contains links to external websites. We are not responsible for the content, privacy practices, or security of any external sites. Users should review the terms and privacy policies of any external websites they visit.
      </p>

      <h2>Use at Your Own Risk</h2>
      <p>
        All information provided on this website is for general informational and research purposes only. Use of this website and reliance on any information is solely at your own risk.
      </p>
    </ArticleLayout>
  );
}